/*
 * Make the MAKE AN OFFER button work.
 *
 * THE BUG, as observed on the live store 2026-10-06:
 * The Offerly app builds its modal (#OfferlyModalDiv) and injects its button
 * (#offerButton) next to ADD TO BAG, and then its setup function throws:
 *
 *     Uncaught TypeError: Cannot read properties of undefined
 *                         (reading 'getBoundingClientRect')
 *
 * It throws inside the app's own areElementsAdjacent(el1, el2), which is called
 * with an element this theme does not give it. That call sits ONE LINE BEFORE
 * the app runs offerButton.addEventListener('click', ...), so the listener is
 * never attached. The result is a button that renders on all 300 product pages
 * and does absolutely nothing when clicked -- while the product copy and the
 * FAQ both tell customers to use it.
 *
 * WHY THIS CAN BE FIXED FROM OUR SIDE:
 * Everything the click needs survives the crash. openOModal(),
 * updateModalInformation() and closeOfferlyModal() are hoisted function
 * declarations, so they exist regardless of where the script died, and the
 * modal markup is already in the DOM with display:none. Only the listener is
 * missing, so only the listener is added here. The app's own code is untouched.
 *
 * ONE DELIBERATE IMPROVEMENT ON THE APP:
 * The app reads its own selectedVariantId global, which its (dead) change
 * handler was supposed to keep updated. This reads the live value out of the
 * product form's [name="id"] input instead, falling back to the app's global.
 * That way the offer carries the metal and karat the customer is actually
 * looking at. Verified: switching to Platinum makes the modal say
 * "White Platinum $2,020", matching the price on the page.
 *
 * SAFE IF THE APP IS EVER FIXED:
 * The button is bound once (guarded by a data attribute), and the handler
 * returns early if the modal is already open, so a working app handler simply
 * wins and this does nothing.
 */
(function () {
  'use strict';

  var BOUND_FLAG = 'data-kas-offer-bound';
  var MAX_TRIES = 40;   // ~10 seconds; the app injects its button asynchronously
  var INTERVAL = 250;

  function appIsReady() {
    return typeof window.openOModal === 'function' &&
           typeof window.updateModalInformation === 'function' &&
           document.getElementById('OfferlyModalDiv') !== null;
  }

  function currentVariantId() {
    var input = document.querySelector('[name="id"]');
    if (input && input.value) {
      return input.value;
    }
    return window.selectedVariantId;
  }

  function onOfferClick(event) {
    var modal = document.getElementById('OfferlyModalDiv');

    // If something already opened it -- a fixed app, or a double binding --
    // leave it alone rather than re-rendering it underneath the customer.
    if (modal && window.getComputedStyle(modal).display !== 'none') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    try {
      window.updateModalInformation(currentVariantId());
    } catch (err) {
      // Showing the modal matters more than filling it in perfectly. If the
      // app cannot populate it, it still opens and the customer can still ask.
      if (window.console && console.warn) {
        console.warn('[kas] Offerly updateModalInformation failed:', err);
      }
    }

    window.openOModal();
  }

  function bind() {
    var button = document.getElementById('offerButton');
    if (!button) {
      return false;             // app has not injected it yet
    }
    if (button.getAttribute(BOUND_FLAG) === '1') {
      return true;              // already done
    }
    if (!appIsReady()) {
      return false;             // modal or functions not there yet
    }
    button.setAttribute(BOUND_FLAG, '1');
    button.addEventListener('click', onOfferClick);
    return true;
  }

  function start() {
    if (bind()) {
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (bind() || tries >= MAX_TRIES) {
        clearInterval(timer);
      }
    }, INTERVAL);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());